import { FieldInstance } from "db/definitions";
import React from "react";

interface UpdateContextInterface {
	setupChanged: (changed: boolean) => void;
	updateObj: Record<string, FieldInstance>;
	linkedAltIds: Record<string, string>;
	linkedData: Record<string, FieldInstance>;
}

const UpdateContext = React.createContext<UpdateContextInterface>({
	updateObj: {},
	setupChanged: () => {},
	linkedAltIds: {},
	linkedData: {},
});

export { UpdateContext };
